export const DataRow = ({ label, value }) =>
  value?.length ? (
    <div className='row'>
      <div className='label'>{label}</div>
      <div className='value'>{value}</div>
    </div>
  ) : null
